module.exports = __webpack_public_path__ + "static/media/39.14f0a637.jpg";